module.exports = __webpack_public_path__ + "static/media/logo.33cc6bca.png";